import {
  UserProfileAddCcDocument,
  UserProfileAddCcMutationResult,
  UserProfileAddCcMutationVariables,
} from "@graphql/api";

export default async function userProfileAddCc(
  id: number,
  ccNumber: string,
  ccExpiration: string,
  ccName: string,
  ccPostalCode?: string,
  ccAddress?: string,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileAddCcMutationVariables = {
    id,
    ccNumber,
    ccExpiration,
    ccName,
    ccPostalCode,
    ccAddress,
  };
  const result: UserProfileAddCcMutationResult = await client.mutate({
    mutation: UserProfileAddCcDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileAddCc.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileAddCc.success;
}
